import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { salesDetailsFetch } from "../../store/SalesDetails/salesDetailsFetch";
import DetailsVue3 from "./pages/DetailsVue3";
import DetailsVue2 from "./pages/DetailsVue2 (BROUN)";
import DetailsVue1 from "./pages/DetailsVue1(sevUrbat )";
import DetailsVue4 from "./pages/DetailsVue4(NewDesign)";
import PageSeo from "../../components/PageSeo";
import getImageUrl from "../../helpers/getImageUrl";
import {
  listingDescription,
  stripHtml,
  truncateText,
  withBrandSuffix,
} from "../../helpers/seoMeta";

const SalesProductDetails = () => {
  const { currentLanguage } = useSelector(({ main }) => main);
  const { isLoading, error, detailsList } = useSelector(
    (state) => state.SalesDetailsSlice
  );
  const dispatch = useDispatch();
  const { id, view } = useParams();

  useEffect(() => {
    if (!detailsList.length) {
      dispatch(salesDetailsFetch(id));
    }
  }, [detailsList.length, dispatch, id]);

  const seoOverride = useMemo(() => {
    const sale = detailsList?.sale;
    const titleName =
      sale?.["title_" + currentLanguage] ||
      sale?.["name_" + currentLanguage] ||
      sale?.["public_name_" + currentLanguage] ||
      sale?.public_name ||
      "";
    const descRaw = sale?.["description_" + currentLanguage] || "";
    const slider =
      detailsList?.sliders?.[0] ||
      detailsList?.gallery?.[0];
    const ogImage = getImageUrl(
      slider?.["image_" + currentLanguage] ||
        slider?.images_source ||
        slider?.image ||
        sale?.["slider_image1_" + currentLanguage] ||
        sale?.["baner_gl_" + currentLanguage]
    );
    if (!titleName) {
      return {
        title: withBrandSuffix(
          currentLanguage === "ru"
            ? "Акция"
            : currentLanguage === "en"
              ? "Promotion"
              : "Ակցիա",
          currentLanguage
        ),
        description: listingDescription("", currentLanguage, "sale"),
        path: `/sale/${id}/${view}`,
        schemaType: "WebPage",
      };
    }
    return {
      title: withBrandSuffix(titleName, currentLanguage),
      description:
        truncateText(stripHtml(descRaw), 160) ||
        listingDescription(titleName, currentLanguage, "sale"),
      path: `/sale/${id}/${view}`,
      schemaType: "CollectionPage",
      ogImage: ogImage || undefined,
      breadcrumbs: [{ name: titleName }],
      itemList:
        detailsList?.products_first_slider ||
        detailsList?.products_second_slider,
    };
  }, [currentLanguage, detailsList, id, view]);

  return (
    <>
      <PageSeo override={seoOverride} />
      {+view === 2 ? (
        <DetailsVue2
          currentLanguage={currentLanguage}
          detailsList={detailsList}
          isLoading={isLoading}
          error={error}
        />
      ) : +view === 3 ? (
        <DetailsVue3
          currentLanguage={currentLanguage}
          detailsList={detailsList}
          isLoading={isLoading}
          error={error}
        />
      ) : +view === 4 ? (
        <DetailsVue4
          currentLanguage={currentLanguage}
          detailsList={detailsList}
          isLoading={isLoading}
          error={error}
        />
      ) : (
        <DetailsVue1
          currentLanguage={currentLanguage}
          detailsList={detailsList}
          isLoading={isLoading}
          error={error}
        />
      )}
    </>
  );
};

export default SalesProductDetails;
